/**
 * 로그인 (공통/보안과개인정보 1-4, 3단계 화면 글자)
 * - "로그인 상태 유지"는 처음에 꺼져 있다. 안 하면 30분 동안 안 쓰거나 창을 닫으면 로그아웃된다.
 * - 동시 접속 정원이 차면 대표님 문구로 묻고 [로그인] [취소].
 * - 최근에 쓴 로그인 방법을 이 컴퓨터가 기억해 "최근 로그인"으로 보여 준다(모양은 디자인 단계에서).
 * - 간편 가입 중 "이미 가입된 사업자"로 넘어왔으면(linkTicket) 로그인하면서 그 카카오(네이버)를 붙인다.
 */
import { useEffect, useState } from 'react';
import { api, lastMethod, rememberMethod, type Who } from '../api.ts';
import { Button, Check, Confirm, Field, Link, Message, Page } from '../ui.tsx';

export function Login(props: { go: (p: string) => void; onSignedIn: (who: Who, note?: string | null) => void; notice: string | null; linkTicket: string | null }) {
  const [login_id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [keep, setKeep] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [confirm, setConfirm] = useState<string | null>(null);
  const [options, setOptions] = useState({ kakao: false, naver: false });
  const recent = lastMethod();

  useEffect(() => {
    void api<{ kakao: boolean; naver: boolean }>('GET', '/api/auth/options').then((r) => {
      if (r.ok) setOptions({ kakao: r.kakao, naver: r.naver });
    });
  }, []);

  async function submit(force: boolean) {
    setError(null);
    const r = await api<{ who: Who; linked: string | null }>('POST', '/api/auth/login', {
      login_id, password, keep_login: keep, force, ...(props.linkTicket ? { link_ticket: props.linkTicket } : {})
    });
    if (r.ok) {
      rememberMethod('아이디');
      setConfirm(null);
      props.onSignedIn(r.who, r.linked);
      return;
    }
    if (r.code === 'confirm_cut') setConfirm(r.message);
    else setError(r.message);
  }

  function social(slug: 'kakao' | 'naver') {
    try {
      sessionStorage.setItem('ilsoni_keep_login', keep ? '1' : '0');
    } catch {
      /* 기억이 막힌 브라우저면 유지하지 않는다 */
    }
    window.location.href = `/api/auth/${slug}/start`;
  }

  const badge = (m: string) => (recent === m ? ' (최근 로그인)' : '');

  return (
    <Page title="일손이">
      <Message text={props.notice} />
      {options.kakao && <Button onClick={() => social('kakao')}>카카오로 로그인{badge('카카오')}</Button>}
      {options.naver && <Button onClick={() => social('naver')}>네이버로 로그인{badge('네이버')}</Button>}
      <h2 style={{ fontSize: 24 }}>아이디로 로그인{badge('아이디')}</h2>
      <Field label="아이디" value={login_id} onChange={setId} autoComplete="username" />
      <Field label="비밀번호" value={password} onChange={setPassword} type="password" autoComplete="current-password" />
      <Check label="로그인 상태 유지" checked={keep} onChange={setKeep} />
      <Message text={error} />
      {confirm
        ? <Confirm text={confirm} ok="로그인" onOk={() => void submit(true)} onCancel={() => setConfirm(null)} />
        : <Button primary onClick={() => void submit(false)}>로그인</Button>}
      <p>
        <Link to="/find/id" go={props.go}>아이디 찾기</Link>
        <Link to="/find/password" go={props.go}>비밀번호 찾기</Link>
        <Link to="/signup" go={props.go}>가입하기</Link>
      </p>
    </Page>
  );
}
